import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
	deleteAdjustment,
	deleteReccuringCredits,
	deletePaymentPromises,
	deleteDiscount,
	deleteTaxExemption
} from '../../../actions/accountDetailsActions/billing.actions';
import { hideModal } from '../../../actions/modal.actions';
import { getModalData } from '../../../selectors';
import {toastr} from "react-redux-toastr";

class DeleteAdjustmentModal extends Component {
	deleteCurrentAdjustment = () => {
		const { accountId, itemId, type } = this.props.modalProps;
		if (type === 'adjustment') {
			this.props.deleteAdjustment(accountId, itemId).then((response) => {
				if (response.data.success) {
					toastr.success(response.data.message, { timeOut: 1000, position: 'top-center' });
					this.props.hideModal();
				} else {
					let errorMessage = response.data.error.code + ":" + response.data.error.message;
					toastr.error(errorMessage, {timeOut: 0, position: 'top-center'});
				}
			});
		} else if (type === 'reccuring') {
			this.props.deleteReccuringCredits(accountId, itemId).then((response) => {
				if (response.data.success) {
                    toastr.success(response.data.message, { timeOut: 1000, position: 'top-center' });
					this.props.hideModal();
				} else {
					let errorMessage = response.data.error.code + ":" + response.data.error.message;
					toastr.error(errorMessage, {timeOut: 0, position: 'top-center'});
				}
			});
		} else if (type === 'discount') {
			this.props.deleteDiscount(accountId, itemId).then((response) => {
				if (response.data.success) {
                    toastr.success(response.data.message, { timeOut: 1000, position: 'top-center' });
					this.props.hideModal();
				} else {
					let errorMessage = response.data.error.code + ":" + response.data.error.message;
					toastr.error(errorMessage, {timeOut: 0, position: 'top-center'});
				}
			});
		} else if (type === 'taxExemption') {
			this.props.deleteTaxExemption(accountId, itemId).then((response) => {
				if (response.data.success) {
                    toastr.success(response.data.message, { timeOut: 1000, position: 'top-center' });
					this.props.hideModal();
				} else {
					let errorMessage = response.data.error.code + ":" + response.data.error.message;
					toastr.error(errorMessage, {timeOut: 0, position: 'top-center'});
				}
			});
		} else if (type === 'paymentPromise') {
			this.props.deletePaymentPromises(accountId, itemId).then((response) => {
				if (response.data.success) {
					toastr.success(response.data.message, { timeOut: 2000, position: 'top-center' })
					this.props.hideModal();
				} else {
					let errorMessage = response.data.error.code + ":" + response.data.error.message;
					toastr.error(errorMessage, { timeOut: 0, position: 'top-center' });
				}
			});
		}
	};

	formatText = () => {
		let text = '';
		switch (this.props.modalProps.type) {
			case 'reccuring':
				return (text = 'Reccuring Credit');
			case 'adjustment':
				return (text = 'Adjustment');
			case 'discount':
				return (text = 'Account Discount');
			case 'taxExemptions':
				return (text = 'Tax Exemption');
			case 'paymentPromise':
				return (text = 'Payment Promise');
			default:
				return text;
		}
	};
	render() {
		return (
			<Fragment>
				<div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">
									{this.props.modalProps.type === 'discount'
										? 'CONFIRM DEACTIVATE ACCOUNT DISCOUNT'
										: `Confirm Delete ${this.formatText()}`}
								</h5>
								<button onClick={this.props.hideModal} type="button" className="close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body">
								{this.props.modalProps.type === 'reccuring' ? (
									<p className="lead">
										{`You are about to remove the recurring credit ${this.props.modalProps.description}
										for the current account, do you want to continue?`} ?
									</p>
								) : this.props.modalProps.type === 'discount' ? (
									<p className="lead">Are you sure you want to deactivate this discount as of the end of this bill cycle?</p>
								) : (
									<p className="lead">Are you sure you want to delete this {this.formatText()}?</p>
								)}
							</div>
							<div className="modal-footer">
								<button onClick={this.props.hideModal} type="button" className="btn">
									No
								</button>
								<button
									onClick={this.deleteCurrentAdjustment}
									type="button"
									className="btn btn-primary"
								>
									Yes
								</button>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-backdrop show" tabIndex="1" />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	const modalProps = getModalData(state).modalProps;
	return {
		modalProps
	};
};

const mapDispatchToProps = {
	hideModal,
	deleteAdjustment,
	deleteDiscount,
	deleteReccuringCredits,
	deletePaymentPromises,
	deleteTaxExemption,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAdjustmentModal);
